/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {Harlequin} from "../Harlequin";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/SoundConfig";

export class ReelStart implements GameRoundPresentation {
    private readonly _reelId:number;
    stagger?:number;
    abortStagger?:number;

    constructor(reelId:number, stagger?:number, abortStagger?:number) {
        this._reelId = reelId;
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public getAnimation(data:ParsedServerData):Timeline | null {
        const tl:Timeline = Harlequin.timelineReelsController.startSpin(this._reelId);
        //let reelController:HarlequinSpinReelController = <HarlequinSpinReelController>Reels.getReel(this._reelId);
        //reelController.updateGameDataOnStart(<ParsedGameData> data);
        // SlotGame.sound.playEffect(SoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START)
        if(this._reelId === 1) {
            tl.add(() => {
                if (SoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START) {
                    SlotGame.sound.playEffect(SoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START);
                }
            }, 0);
        }

        return tl || null;//Harlequin.timelineReelsController.startSpin(this._reelId);
    }

}